const baseUrl = "Webhook";

export const tiggerRemitaPaymentUrl = (rrr) => `${baseUrl}/remita-payment?rrr=${rrr}`;
